<template>
  <div>
    <vs-select
      v-model="selected"
      placeholder="choose reason"
      :multiple="isMultiple"
      :filterable="true"
    >
      <vs-select-item
        :key="index"
        :value="item.ID"
        :text="item.reason"
        v-for="(item, index) in options"
      />
    </vs-select>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/repositoryFactory";
const masterRepository = RepositoryFactory.get("master");

export default {
  props: {
    isGetData: {
      type: Boolean,
      default: true,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    reasonGroup: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      options: [],
      selected: null,
      params: {
        reason_group: this.reasonGroup,
      },
    };
  },
  methods: {
    async setByID(id) {
      try {
        const resp = await masterRepository.getMasterReasonByID(id);
        if (resp.code == 200) {
          this.selected = resp.data;
        } else {
          this.$vs.notify({
            title: "Error",
            text: "Error while fetching master reason",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          console.log(resp);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while fetching master reason",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        console.log(error);
      }
    },
    async getData() {
      try {
        const resp = await masterRepository.getMasterReason({
          params: this.params,
        });
        if (resp.code == 200) {
          var options = [];
          resp.data.records.forEach(function (item) {
            options.push(item);
          }, options);
          this.options = options;
        } else {
          this.$vs.notify({
            title: "Error",
            text: "Error while fetching master reason",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          console.log(resp);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while fetching master reason",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        console.log(error);
      }
    },
  },
  watch: {
    selected(v) {
      this.selected = v;
      this.$emit("data", v);
    },
  },
  mounted() {
    if (this.isGetData) {
      this.getData();
    }
  },
};
</script>
